<!-- Default download button (track-item, track-mob-controls, player) -->
@if (demoDownloading && parentComponent !== 'track-item-header' && !showIconBtnVariant) {
  <a
    class="btv-icon-download"
    [ngClass]="{
      'theme-player__downloadBeatIcon': parentComponent === 'player',
      'theme-beats__downloadBeatIcon': parentComponent === 'track-item',
      'theme-beats__dropdownControlsIcons': parentComponent === 'track-mob-controls'
    }"
    href="{{ downloadMp3Url }}?download=true"
    (click)="downloadBeat($event)"
    target="_blank"
  >
    @if (parentComponent === 'track-mob-controls') {
      <div class="down-btn__title theme-beats__dropdownControlsIcons">
        {{ lg.tracksBlock.downloadDrop }}
      </div>
    }
  </a>
}

<!-- Button on track page: bmcore-track-item-page.component -->
@if (demoDownloading && parentComponent === 'track-item-header') {
  <div class="btn-download theme-headerBlockBeatPage__downloadBeatBtn">
    <a
      class="btv-icon-download btv-icon-download--onTrackPage theme-headerBlockBeatPage__downloadBeatBtn"
      href="{{ downloadMp3Url }}?download=true"
      (click)="downloadBeat($event)"
      target="_blank"
    >
    </a>
  </div>
}

<!-- Download button with new svg icon component mobile player -->
@if (demoDownloading && showIconBtnVariant) {
  <a
    class="btn-download download-btn--player-mob-lg"
    href="{{ downloadMp3Url }}?download=true"
    (click)="downloadBeat($event)"
    target="_blank"
  >
    <bmcore-download-icon [height]="iconSize" [width]="iconSize"></bmcore-download-icon>
  </a>
}
